import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export const asset = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u || "");

// Smaller WebP copy (480/900/1400 wide) of an uploaded jpg/png/webp; anything else is returned untouched.
const RESIZABLE = /^\/api\/files\/.+\.(jpe?g|png|webp)$/i;
export const thumb = (u, w) => (u && RESIZABLE.test(u) ? `${asset(u)}?w=${w}` : asset(u));
export const thumbSet = (u) => (u && RESIZABLE.test(u) ? [480, 900, 1400].map((w) => `${asset(u)}?w=${w} ${w}w`).join(", ") : undefined);

export const CATEGORY_LABEL = { art: "ART", comic: "COMIC", vignette: "VIGNETTE", animation: "ANIMATION" };

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail?.msg || String(detail);
}
